export const SIGNUP = {
  TITLE: 'Sign Up',
  USERNAME: 'Username',
  PASSWORD: 'Password',
  EMAIL: 'Email',
  FULL_NAME: 'Full Name',
  BUTTON: 'Sign Up',
  SUCCESS: 'Sign up successful',
}

export const RESET_PASSWORD = {
  TITLE: 'Reset Password',
  EMAIL: 'Email',
  BUTTON: 'Reset Password',
  EMAIL_SENT: 'Password reset email sent, please check your inbox',
  NEW_PASSWORD: 'New Password',
  PASSWORD_UPDATED: 'Password updated, please login again',
  INVALID_TOKEN: 'Your token is invalid, maybe it has expired. Please, try again',
  PASSWORD_UPDATE_FAILED: 'Failed to update password',
  MAIL: {
    SUBJECT: 'Reset your password',
    BODY: (url: string) => `Click <a href="${url}">here</a> to reset your password`,
  },
}

export const GOOGLE_SSO_SUCCESS = {
  TITLE: 'Google SSO Success',
  SUBTITLE: 'You have authenticated with Google',
  BUTTON: 'Close Window',
}

export const LOGIN = {
  WELCOME: 'Welcome Back!',
  TITLE: 'Sign into Qalea platform',
  EMAIL: 'Enter your email address',
  BUTTON: 'Send me the login link',
  GOOGLE_SSO_BUTTON: 'Sign in with Google',
  MICROSOFT_SSO_BUTTON: 'Sign in with Microsoft',
  PROBLEMS_LOGIN: 'Problems signing in?',
  CLICK_HERE: 'Click here',
  OR_DIVIDER: 'or',
  DESCRIPTION: 'Need an account?',
  CONTACT: 'Talk with us',
  REDIRECTING: 'Redirecting to your account...',
  USER_NOT_FOUND: 'It seems that we do not have any user with this email in our system',
  MAGIC_LINK_SUBJECT: "Qalea's Magic Link",
  MAGIC_LINK_ERROR: 'Failed to send magic link',
  MAGIC_LINK_TEXT: (url: string, userFullName: string | null, organizationName: string) => `
  <div style="font-family: Arial, sans-serif; line-height: 1.6; color: #333;">
    <p>Hello ${userFullName},</p>
    <p>Please click the link below to log in to your account as a ${organizationName} user:</p>
    <p><a href="${url}" style="color: #007bff; text-decoration: none;">Log in to Qalea</a></p>
    <p>If you didn't request this link, you can safely ignore this email.</p>
    <p>Thank you,<br>Qalea Team</p>
  </div>
`,
  MAGIC_LINK_SENT: 'Magic link sent, please check your inbox',
  SSO_FAILED: 'Single Sign-On failed. Please try again or contact us.',
  ERROR: 'Something went wrong, please try again',
}

export const SYSTEM_USE_NOTICE = {
  TITLE: 'System Use Notice',
  MESSAGE:
    'Access to and use of this system is governed by the terms and conditions established by Qalea. By accessing this system, you acknowledge that you have read, understood, and agree to comply with those terms and any responsibilities arising from your use.',
  MESSAGE_AUDIT:
    'This system may log user activity for security and audit purposes. For full details, please review our',
  TERMS_OF_SERVICE: 'Terms of Service',
  PRIVACY_POLICY: 'Privacy Policy',
  AND: 'and',
  ACCEPT: 'Accept',
}
